var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 60,
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 136,
    height: 72
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 84,
    y1: 60,
    x2: 84,
    y2: 36
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 108,
    y1: 60,
    x2: 108,
    y2: 36
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 132,
    y1: 60,
    x2: 132,
    y2: 36
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 156,
    y1: 60,
    x2: 156,
    y2: 36
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 60,
    y1: 60,
    x2: 60,
    y2: 36
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 36,
    y1: 60,
    x2: 36,
    y2: 36
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 84,
    y1: 156,
    x2: 84,
    y2: 132
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 108,
    y1: 156,
    x2: 108,
    y2: 132
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 132,
    y1: 156,
    x2: 132,
    y2: 132
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 156,
    y1: 156,
    x2: 156,
    y2: 132
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 60,
    y1: 156,
    x2: 60,
    y2: 132
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 36,
    y1: 156,
    x2: 36,
    y2: 132
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpu);
export default __webpack_public_path__ + "static/media/cpu.482f9a6d3772c3a465c8d0f6d213237e.svg";
export { ForwardRef as ReactComponent };